import { React, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Form.css";
import Image from "../../assets/mecs.jpg";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";
import config from "../../common/config.ts";

// real time validation for form fields
const schema = yup.object().shape({
  name: yup.string().required("First name is required!"),
  lastName: yup.string().required("Last name is required!"),
  depart_or_org: yup.string().required("Organization and department is required!"),
  eventName: yup.string().required("Event name is required"),
  eventType: yup.string().required("Event type is required"),
  startDate: yup.string().required("Start date is required"),
  endDate: yup.string().required("End date is required"),
  endDate: yup.string().required("End date is required"),
  multipleDates: yup.string().required("Time frame is required"),
  email: yup
    .string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email")
    .required("Email is required"),
  phoneNumber: yup
    .string()
    .matches(/^[0-9-]+$/, "Invalid format, please use xxx-xxx-xxxx")
    .required("Phone number is required"),
  address: yup.string().required("Address is required!"),
  city: yup.string().required("City is required!"),
  province: yup.string().required("Province / state is required!"),
  country: yup.string().required("Country is required!"),
  postalCode: yup.string().required("Postal Code is required!"),
  numAttendees: yup.string().required("Number of attendees is required!"),
  comments: yup.string().required("Comments are required!"),
  referral: yup.string().required("Referral is required!"),
});

function Form() {
  console.log("We are here: " + window.location.hostname);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
  } = useForm({
    mode: "all",
    resolver: yupResolver(schema),
  });
  const [locationOptions, setLocationOptions] = useState("");
  const [eventType, setEventTypeOptions] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [referral, setReferralOptions] = useState("");
  const [AdditionalServices, setSelectedAdditionalServicesOptions] = useState("");
  const [AdditionalServicesOptions, setOptions] = useState([
      { id: 1, value: 'Audio visual services', isChecked: false },
      { id: 2, value: 'Food and beverage services', isChecked: false },
      { id: 3, value: 'Bar/ alcohol services', isChecked: false },
      { id: 4, value: 'Security', isChecked: false },
      { id: 5, value: 'Program services', isChecked: false },
      { id: 6, value: 'Registration', isChecked: false },
      { id: 7, value: 'Social events', isChecked: false },
      { id: 8, value: 'Field trips', isChecked: false },
      { id: 9, value: 'Accommodations', isChecked: false },
      { id: 10, value: 'Marketing', isChecked: false },
      { id: 11, value: 'Exhibition/ trade shows', isChecked: false },
      { id: 12, value: 'Accessibility services', isChecked: false },
    ]);
    const [AdditionalServicesVirtual, setSelectedAdditionalServicesOptionsVirtual] = useState("");
    const [AdditionalServicesOptionsVirtual, setOptionsVirtual] = useState([
        { id: 1, value: 'Full supported webinar/ meeting', isChecked: false },
        { id: 2, value: 'Zoom License only meeting', isChecked: false },
        { id: 3, value: 'Tech Support for client/ run zoom meeting', isChecked: false },
      ]);
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [startDates, setStartDate] = useState("");
      const [endDates, setEndDate] = useState("");
      const [dateError, setError] = useState("");
      const closeModal = () => {
        setIsModalOpen(false); // Updates state to close the modal
        window.location.reload(); // reload the page
      };

      const Modal = ({ isOpen, onClose, children }) => {
        if (!isOpen) return null;
      
        return (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '5px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              {children}
              <button onClick={onClose} style={{ marginTop: '10px' }}>Close</button>
            </div>
          </div>
        );
      };
      
      

  // handles data received from form
  const onSubmit = async (data) => {
    try {
      console.log(data);
      //console.log(calltoPI())    // get bearer token from PItask
      console.log("call for service token has completed...");
      postData(data); // make call to momentus using token
      console.log("both calls completed...");
    } catch (error) {
      console.error("Error occured during form submission", error);
    }
  };

  const handleCheckboxChange = (id) => {
    const newOptions = AdditionalServicesOptions.map(option => {
      if (option.id === id) {
        return { ...option, isChecked: !option.isChecked };
      }
      return option;
    });
    setOptions(newOptions);

    let selected = "";
    for (let option of newOptions) {
      if (option.isChecked) {
        if (!selected || selected.length === 0)
          selected = option.value;
        else
          selected += ", " + option.value;
      }
    }
    setSelectedAdditionalServicesOptions(selected);
  };

  const handleCheckboxChangeVirtual = (id) => {
    const newOptions = AdditionalServicesOptionsVirtual.map(option => {
      if (option.id === id) {
        return { ...option, isChecked: !option.isChecked };
      }
      return option;
    });
    setOptionsVirtual(newOptions);

    let selected = "";
    for (let option of newOptions) {
      if (option.isChecked) {
        if (!selected || selected.length === 0)
          selected = option.value;
        else
          selected += ", " + option.value;
      }
    }
    setSelectedAdditionalServicesOptionsVirtual(selected);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date); 
  };

  const handleEndDateChange = (date) => {
   
    if (startDates && new Date(date) < new Date(startDates)) {
      setError("End date can not be earlier than start date.");
    } else {
      setError("");
    }
  };

  // do post call to get PIC auth token
  async function calltoPI() {
    const serviceAccount = {
      accountName: `${config.ACCOUNT_NAME}`,
      password: `${config.PASSWORD}`,
      context: "All",
    };
    let bearerToken = "";
    try {
      console.log(url());
      const responseToken = await axios.post(
        `${url()}/auth/token`,
        serviceAccount
      );
      bearerToken = responseToken.data.serviceToken;
      return bearerToken;
    } catch (error) {
      console.log(error);
    }
  }

  // create  new event in momentus
  async function postData(formData) {
    setIsLoading(true);
    const token = await calltoPI();

    console.log(token);
    // set the header for the post call
    formData.name = formData.name + " " + formData.lastName;
    formData.startDate = moment(formData.startDate).format(
      "YYYY-MM-DD hh:mm:ss A"
    );
    formData.endDate = moment(formData.endDate).format("YYYY-MM-DD hh:mm:ss A");
    formData.AdditionalServices = formData.locationOptions === "Virtual" ? formData.AdditionalServicesVirtual[0] : formData.AdditionalServices[0];
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      console.log(url());
      //const NewDate = moment(yourDate, 'DD-MM-YYYY')
      //import moment from 'moment';
      const response = await axios.post(
        `${url()}/ungerboeck/PostMecsEventBooking`,
        formData,
        { headers }
      );
      console.log("Data updated successfully", response.data);
      setIsModalOpen(true);
      //alert("Event submitted successfully!");
      //window.location.reload(); // reload the page
    } catch (error) {
      // Handle any error that occurred during the request
      console.error("Error updating data:", error);
      alert("Error!");
    }
    setIsLoading(false);
  }

  function url() {
    var authURL =  `${config.PLATFORMAPI}`;
    const hostName = window.location.hostname;
    console.log(hostName);
    if (hostName === "mecsevent.its.sfu.ca") {
      // no type coercion
      authURL = "https://platformtask.its.sfu.ca";
    }
    return authURL;
  }

  

   

  // handle changes in location dropdown
  const handleLocationChange = (event) => {
    let locationChosen = event.target.value;
    console.log(locationChosen);
    setLocationOptions(locationChosen);
    if (locationChosen != "") {
      if (locationChosen === "Virtual") {
        showFeature("additionalServicesVirtualSection");
        hideFeature("inPersonSection");
        hideFeature("inPersonSection1");
      } else {
        hideFeature("additionalServicesVirtualSection");
        showFeature("inPersonSection");
        showFeature("inPersonSection1");
      }
      showFeature("formDescription");
      showFeature("bottom_half");
    } else {
      hideFeature("locationName");
      hideFeature("formDescription");
      hideFeature("bottom_half");
      hideFeature("additionalServicesVirtualSection");
      hideFeature("inPersonSection");
      hideFeature("inPersonSection1");
    }
  };

  const handleEventTypeChange = (event) => {
    let eventTypeChosen = event.target.value;
    setEventTypeOptions(eventTypeChosen);
  };

  const handleReferralChange = (event) => {
    let referralChosen = event.target.value;
    setReferralOptions(referralChosen);
  };

  function showFeature(featureId) {
    document.getElementById(featureId).style.display = "block";
  }

  function hideFeature(featureId) {
    document.getElementById(featureId).style.display = "none";
  }

  // change the textContent
  function changeTextAndShow(featureId, newText) {
    document.getElementById(featureId).textContent = newText;
    document.getElementById(featureId).style.display = "block";
  }

  // reset the location if user chooses "No option/Virtual on first dropdown"
 /*  function resetLocation() {
    setLocationOptions("");
  }
 */
  return (
    <div className="container">
      <div className="top_half">
        <center><img src={Image} alt="An event being hosted by MECS" id="mecs-image" /></center>
        <h1 id="locationName">LOCATION</h1>
        <br /><br />
        Thank you for considering our venue for your event! Please fill out the following details to help us understand your requirements.
        We look forward to making your event a memorable experience.
         <br /><br /><br />
      

        <label id="locOptionsLabel" htmlFor="locationOptions">
          Please choose a location...
        </label>
        <select
          id="locationOptions"
          value={locationOptions}
          {...register("locationOptions")}
          onChange={handleLocationChange}
        >
          <option value="">No option chosen...</option>
          <option value="Vancouver">Vancouver</option>
          <option value="Burnaby">Burnaby</option>
          <option value="Surrey">Surrey</option>
          <option value="AnyCampus">Any Campus</option>
          <option value="Virtual">Virtual</option>
        </select>

        <div id="formDescription">
          <h2>Request a space</h2>
          Please fill out this form and click the submit button at the bottom left. 
          A representative will respond to your request by phone or email as soon as possible.
          <br />
          Note: Fields marked with an asterisk (<span>*</span>) are required. 
        </div>
      </div>
      <div id="bottom_half">
        <h2>Contact information</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <section id="contact_info_section">
            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  First name<span>*</span>
                </label>
                <input id="name" className="form-input" {...register("name")} />
                {errors.name && (
                  <p className="errorMessage">{errors.name.message}</p>
                )}
              </div>
              &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="lastName" className="form-label">
                 Last name<span>*</span>
                </label>
                <input id="lastName" className="form-input" {...register("lastName")} />
                {errors.lastName && (
                  <p className="errorMessage">{errors.lastName.message}</p>
                )}
              </div>
            </div>

            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="depart_or_org" className="form-label">
                  Organization and department <span>*</span>
                </label>
                <input
                  id="depart_or_org"
                  className="form-input"
                  {...register("depart_or_org")}
                />
                {errors.depart_or_org && (
                  <p className="errorMessage">{errors.depart_or_org.message}</p>
                )}
              </div>
              &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="title" className="form-label">
                  Title
                </label>
                <input
                  id="title"
                  className="form-input"
                  {...register("title")}
                />
                {errors.title && (
                  <p className="errorMessage">{errors.title.message}</p>
                )}
              </div>
            </div>


            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="address" className="form-label">
                  Address <span>*</span>
                </label>
                <input
                  id="address"
                  className="form-input"
                  placeholder="Address"
                  {...register("address")}
                />
                {errors.address && (
                  <p className="errorMessage">{errors.address.message}</p>
                )}
              </div>
              &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="city" className="form-label">
                  City <span>*</span>
                </label>
                <input id="city" className="form-input" {...register("city")} />
                {errors.city && (
                  <p className="errorMessage">{errors.city.message}</p>
                )}
              </div>
            </div>

            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email <span>*</span>
                </label>
                <input
                  id="email"
                  className="form-input"
                  {...register("email")}
                />
                {errors.email && (
                  <p className="errorMessage">{errors.email.message}</p>
                )}
              </div>
              &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="phoneNumber" className="form-label">
                  Phone <span>*</span>
                </label>
                <input
                  id="phoneNumber"
                  type="tel"
                  className="form-input"
                  placeholder="Phone Number"
                  {...register("phoneNumber")}
                />
                {errors.phoneNumber && (
                  <p className="errorMessage">{errors.phoneNumber.message}</p>
                )}
              </div>
            </div>

            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="province" className="form-label">
                  Province/ state <span>*</span>
                </label>
                <input
                  id="province"
                  className="form-input"
                  {...register("province")}
                />
                {errors.province && (
                  <p className="errorMessage">{errors.province.message}</p>
                )}
              </div>
              &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="country" className="form-label">
                  Country <span>*</span>
                </label>
                <input
                  id="country"
                  type="tel"
                  className="form-input"
                  {...register("country")}
                />
                {errors.country && (
                  <p className="errorMessage">{errors.country.message}</p>
                )}
              </div>
            </div>

            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="postalCode" className="form-label">
                  Postal code <span>*</span>
                </label>
                <input
                  id="postalCode"
                  className="form-input"
                  {...register("postalCode")}
                />
                {errors.postalCode && (
                  <p className="errorMessage">{errors.postalCode.message}</p>
                )}
              </div>
            </div>
          </section>

          <section id="request_details_section">
            <h2>Request details</h2>
            <div className="form-group">
              <label htmlFor="eventName" className="form-label">
                Event name/ title <span>*</span>
              </label>
              <input
                id="eventName"
                className="form-input"
                {...register("eventName")}
              />
              {errors.eventName && (
                <p className="errorMessage">{errors.eventName.message}</p>
              )}
              <br />
            </div>

            <div className="form-group">
              <label htmlFor="eventType" className="form-label">
                Type of event <span>*</span>
              </label>
              <select
                id="eventType"
                value={eventType}
                className="form-input"
                {...register("eventType")}
                onChange={handleEventTypeChange}
              >
                <option value="">Select an event type</option>
                <option value="MWT">Meetings, workshops and seminars</option>
                <option value="CET">Conferences, symposiums and exhibitions</option>
                <option value="SEC">Special events and ceremonies</option>
                <option value="FIL">Filming and production services</option>
                <option value="CLA">Class</option>
                <option value="OTH">Other</option>
              </select>
              {errors.eventType && (
                <p className="errorMessage">{errors.eventType.message}</p>
              )}
            </div>

            {/** we use Controller to connect components from third party UI; - which are not standard HTML components*/}
            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="startDate" className="form-label">
                  Start date <span>*</span>
                </label>
                <Controller
                  control={control}
                  name="startDate"
                  render={({ field }) => (
                    <DatePicker
                      id="startDate"
                      showTimeSelect={false}
                      dateFormat="yyyy-MM-dd"
                      valueFormat="yyyy-MM-dd"
                      minDate={new Date()}  // Prevent selection of past dates
                      selected={field.value}
                      onChange={(date) => {field.onChange(date); handleStartDateChange(date);}}       
                    />
                  )}
                />
                {errors.startDate && (
                  <p className="errorMessage">{errors.startDate.message}</p>
                )}
              </div>
              &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="endDate" className="form-label">
                  End date <span>*</span>
                </label>
                <Controller
                  control={control}
                  name="endDate"
                  render={({ field }) => (
                    <DatePicker
                      id="endDate"
                      showTimeSelect = {false}
                      dateFormat="yyyy-MM-dd"
                      valueFormat="yyyy-MM-dd"
                     // minDate={new Date()}  // Prevent selection of past dates
                      minDate={startDates}
                      selected={field.value}
                      onChange={(date) => {field.onChange(date); handleEndDateChange(date);}}
                    />
                  )}
                />
                {errors.endDate && (
                  <p className="errorMessage">{errors.endDate.message}</p>
                )}
              {dateError && <p style={{ color: "red" }}>{dateError}</p>}
              </div>
            </div>
            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="multipleDates" className="form-label">
                What are the start and end times of your event? <span>*</span>
                </label>
                <textarea
                  id="multipleDates"
                  className="form-input"
                  rows="6"
                  cols="24"
                  maxlength={200}
                  placeholder="Please specify the required times..."
                  {...register("multipleDates")}
                />
                {errors.multipleDates && (
                  <p className="errorMessage">{errors.multipleDates.message}</p>
                )}
              </div>
             {/*  &nbsp;&nbsp;
              <div className="form-group">
                <label htmlFor="preferredSetup" className="form-label">
                  Preferred Setup <span>*</span>
                </label>
                <input
                  id="preferredSetup"
                  className="form-input"
                  {...register("preferredSetup")}
                />
                {errors.preferredSetup && (
                  <p className="errorMessage">
                    {errors.preferredSetup.message}
                  </p>
                )}
              </div> */}
            </div>

            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="numAttendees" className="form-label">
                  Anticipated number of attendees <span>*</span>
                </label>
                <input
                  type = "number"
                  id="numAttendees"
                  className="form-input"
                  min="1"
                  {...register("numAttendees")}
                />
                {errors.numAttendees && (
                  <p className="errorMessage">{errors.numAttendees.message}</p>
                )}
                 &nbsp;&nbsp;
                 <label htmlFor="numAttendeesNote" className="form-labelNote">
                 Requests for events with 100 or more attendees require up to 6 weeks for approval, and additional security may be necessary.<span></span>
              </label>
              </div>
            </div>

           
            
            <section id="additionalServicesVirtualSection">
            <div className="form-groupRow">
            <div className="form-group">
            <label htmlFor="additionalServicesVirtual" className="form-label">
              Please identify the additional services anticipated for your event - (select all that apply) <span></span>
              </label>
      <div className = "multiSelect">
        {AdditionalServicesOptionsVirtual.map((option) => (
          <div key={option.id}>
            <input
              type="checkbox"
              id={`checkbox-${option.id}`}
              checked={option.isChecked}
              value={AdditionalServicesVirtual}
              {...register("AdditionalServicesVirtual")}
              onChange={() => handleCheckboxChangeVirtual(option.id)}
            />
            <label className="multiSelect" htmlFor={`checkbox-${option.id}`}>{option.value}</label>
          </div>
        ))}
      </div>
      &nbsp;&nbsp;
      <label htmlFor="additionalServicesVirtualNote" className="form-labelNote">
      All services are exclusively provided and expertly managed by MECS.<span></span>
              </label>
    </div>
            </div>
            </section>

            <section id="inPersonSection">
            <div className="form-groupRow">
            <div className="form-group">
            <label htmlFor="additionalServices" className="form-label">
              Please identify the additional services anticipated for your event - (select all that apply) <span></span>
              </label>
      <div className = "multiSelect">
        {AdditionalServicesOptions.map((option) => (
          <div key={option.id}>
            <input
              type="checkbox"
              id={`checkbox-${option.id}`}
              checked={option.isChecked}
              value={AdditionalServices}
              {...register("AdditionalServices")}
              onChange={() => handleCheckboxChange(option.id)}
            />
            <label className="multiSelect" htmlFor={`checkbox-${option.id}`}>{option.value}</label>
          </div>
        ))}
      </div>
      &nbsp;&nbsp;
      <label htmlFor="additionalServicesNote" className="form-labelNote">
      All services are offered through our exclusive partnerships and expertly managed by MECS.<span></span>
              </label>
    </div>
            </div>
            </section>


            <div className="form-groupRow">
              <div className="form-group">
                <label htmlFor="gp36publicInterest" className="form-label">
                Will the organization, event, leadership, or speakers attract media attention or public interest? <span></span>
                </label>

                <label className="form-radioButtonInput">
                  Yes
                  <input
                    type="radio"
                    value="Yes"
                    {...register("gp36publicInterest")}
                  />
                </label>
                <label className="form-radioButtonInput">
                  No
                  <input
                    type="radio"
                    value="No"
                    {...register("gp36publicInterest")}
                    defaultChecked
                  />
                </label>
                <label className="form-radioButtonInput">
                  Not sure
                  <input
                    type="radio"
                    value="Not Sure"
                    {...register("gp36publicInterest")}
                  />
                </label>
              </div>
            </div>

            <section id="inPersonSection1">
              <div className="form-groupRow">
                <div className="form-group">
                  <label htmlFor="gp36externalSecurity" className="form-label">
                  Will your event include a public figure (e.g., elected official, dignitary, celebrity, or similar), or a person or persons who is at times assigned a security detail?<span></span>
                  </label>

                  <label className="form-radioButtonInput">
                    Yes
                    <input
                      type="radio"
                      value="Yes"
                      {...register("gp36externalSecurity")}
                    />
                  </label>
                  <label className="form-radioButtonInput">
                    No
                    <input
                      type="radio"
                      value="No"
                      {...register("gp36externalSecurity")}
                      defaultChecked
                    />
                  </label>
                  <label className="form-radioButtonInput">
                  Not sure
                  <input
                    type="radio"
                    value="Not Sure"
                    {...register("gp36externalSecurity")}
                  />
                </label>
                </div>
              </div>

            <div className="form-groupRow">
                <div className="form-group">
                  <label htmlFor="gp36Advertising" className="form-label">
                  Will you be issuing a press release or coordinating with news media and PR channels in advance of your event?<span></span>
                  </label>

                  <label className="form-radioButtonInput">
                    Yes
                    <input
                      type="radio"
                      value="Yes"
                      {...register("gp36Advertising")}
                    />
                  </label>
                  <label className="form-radioButtonInput">
                    No
                    <input
                      type="radio"
                      value="No"
                      {...register("gp36Advertising")}
                      defaultChecked
                    />
                  </label>
                  <label className="form-radioButtonInput">
                  Not sure
                  <input
                    type="radio"
                    value="Not Sure"
                    {...register("gp36Advertising")}
                  />
                </label>
                </div>
              </div>

              <div className="form-groupRow">
                <div className="form-group">
                  <label htmlFor="gp36Controversy" className="form-label">
                  Has the event, topic or featured guest(s) created controversy or protest previously?<span></span>
                  </label>

                  <label className="form-radioButtonInput">
                    Yes
                    <input
                      type="radio"
                      value="Yes"
                      {...register("gp36Controversy")}
                    />
                  </label>
                  <label className="form-radioButtonInput">
                    No
                    <input
                      type="radio"
                      value="No"
                      {...register("gp36Controversy")}
                      defaultChecked
                    />
                  </label>
                  <label className="form-radioButtonInput">
                  Not sure
                  <input
                    type="radio"
                    value="Not Sure"
                    {...register("gp36Controversy")}
                  />
                </label>
                </div>
              </div>
              </section>

            <div className="form-group">
              <label htmlFor="comments" className="form-label">
              Additional comments (Please identify any alternative dates, layout preferences, breakout rooms, specified audio visual or other requirements) <span>*</span>
              </label>
              <textarea
                id="comments"
                className="form-input"
                rows="6"
                cols="24"
                placeholder=""
                maxlength={250}
                {...register("comments")}
              />
              {errors.comments && (
                <p className="errorMessage">{errors.comments.message}</p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="referralType" className="form-label">
                How did you hear about us? <span>*</span>
              </label>
              <select
                id="referral"
                value={referral}
                className="form-input"
                {...register("referral")}
                onChange={handleReferralChange}
              >
                <option value="">Select a referral type</option>
                <option value="WO">Website online form</option>
                <option value="CRF">Referral</option>
                <option value="REC">Repeat client</option>
                <option value="RIC">Repeat SFU client</option>
                <option value="NE">Networking event</option>
                <option value="AD">Advertising</option>
              </select>
              {errors.referral && (
                <p className="errorMessage">{errors.referral.message}</p>
              )}
            </div>
          </section>
          {isLoading ? (
            <div className="spinner"></div>
          ) : (
            <button className="btnSubmit" type="submit">
              Submit
            </button>
          )}

        
        <br />
       <h4>Please be patient with us while we launch our new booking system. If you don’t hear back from us within 48 hours please contact us at (778) 782-7726 or email meet@sfu.ca</h4>
    

        </form>
        
        <Modal isOpen={isModalOpen} 
        onClose={closeModal}> 
         <b>Thank you for your submitting your booking request!</b> <br></br><br></br>This confirmation message verifies that SFU MECS received your request,
          and our expert sales <br></br>team will connect with you within 2 business days to explore your needs and discuss the next steps in detail.<br></br>
        </Modal>
      </div>
    </div>
  );
}

export default Form;
